<template>
  <ButtonDefault :callback="callback" :green="true" :loading="loading"
  :type="'submit'" :block="true" class="black-text">
    Enviar código
  </ButtonDefault>
</template>

<script>
import ButtonDefault from '@/components/misc/Button.vue';

export default {
  name: 'BtnEnviarCodigo',
  components: {
    ButtonDefault,
  },
  props: {
    callback: { type: Function, required: false, default: () => {} },
    loading: { type: Boolean, required: false, default: false },
  },
};
</script>
